import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';

export enum EBillingStatus {
  OK = 'ok',
  UNSTABLE = 'unstable',
}

export interface IBillingProblemReasons {
  deposit?: string | null;
  identification?: string | null;
}

export interface IBillingStatus {
  /** Статус платежа */
  status: EBillingStatus;
  /** Поясняющие тексты */
  problemReasons?: IBillingProblemReasons;
}

export interface IGetBillingStatusDependencies {
  logger: ILogger;
  httpApi: IHttpApi;
}
